export default [
{
    path: '/servicerepair/apply',
    meta: {
        title: '登记报修',
    },
    component: r => require.ensure([], () => r(require(`./apply.vue`)), `/servicerepair`),
},
{
    path: '/servicerepair/list',
    meta: {
        title: '报修列表',
    },
    component: r => require.ensure([], () => r(require(`./repair_list.vue`)), `/servicerepair`),
},
{
    path: '/servicerepair/detail',
    meta: {
        title: '我的报修详情',
    },
    component: r => require.ensure([], () => r(require(`./repair_detail.vue`)), `/servicerepair`),
}
]


// WEBPACK FOOTER //
// ./src/views/ServiceRepair/router.js